/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { PhxDisplayedStep, PhxExtendedMark } from './phx-slider.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'phx-slider-step',
  template: `
    <div class="phx-slider-step">
      <span
        class="phx-slider-dot"
        *ngFor="let mark of phxSteps; trackBy: trackById"
        [class.phx-is-active]="mark.config?.active"
        [class.phx-is-hidden]="mark.config?.hideTick"
        [ngStyle]="mark.style!"
      >
        <svg width="4" height="24" viewBox="0 0 4 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id=".step-indicators">
            <path id="line" d="M2 0V4" stroke-width="2"/>
            <path id="line_2" d="M2 20V24" stroke-width="2"/>
          </g>
        </svg>
      </span>
    </div>
  `
})
export class PhxSliderStepComponent implements OnChanges {

  @Input() phxMarksArray: PhxExtendedMark[] = [];

  phxSteps: PhxDisplayedStep[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    const { phxMarksArray } = changes;

    if (phxMarksArray) {
      this.buildSteps();
    }
  }

  trackById(_index: number, step: PhxDisplayedStep): number {
    return step.value;
  }

  private buildSteps(): void {
    const orient = 'left';

    this.phxSteps = this.phxMarksArray.map(mark => {
      const { value, config } = mark;
      let offset = mark.offset;

      return {
        value,
        offset,
        config,

        active: false,
        style: {
          [orient]: `${offset}%`
        }
      };
    });
  }
}